/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HmfSelectorComponent } from '@dsg-tech/homefield-angular';

import { ReviewToggleSelectComponent } from './review-toggle-select.component';

@NgModule({
	imports: [CommonModule, HmfSelectorComponent],
	declarations: [ReviewToggleSelectComponent],
	exports: [ReviewToggleSelectComponent]
})
export class ReviewToggleSelectModule {}
